namespace advisorop.components.common {

    class SelectCuRTQController {
        onRtqSelected: any;
        onRtqCu: any;
        enableRtqSelect: boolean;
        rtqType: number;
        rtqTypeDesc: string = "";
        rtqDescription: string = "";
        titleId: number;
        household: domains.IHousehold;
        rtq: domains.IRTQ;
        rtqs: Array<domains.IRTQ> = [];        

        selRTQ: domains.IRTQ;
        question: domains.IQuestion;
        questionIndex: number;
        results: Array<domains.IQuestionResult>;
        result: domains.IQuestionResult;
        questionnaire: domains.IQuestionnaire;

        isRTQFormVisible: boolean = false;
        showQuestionnaire: boolean = false;

        currentDate: Date;
        curDate: Date;        
        onGroupNameUpdated: any;

        selGroupId: number;
        buttonDisabled: boolean = false;

        static $inject = ["advisorService"];
        constructor(private advisorService: services.AdvisorService) {

            this.currentDate = new Date();
                 
        }

        selectedRTQChanged(): void {
            this.onRtqSelected({ rtq: this.selRTQ });
        };

        selectRTQ(rtq: domains.IRTQ) {
            this.selRTQ = rtq;
            this.onRtqSelected({ rtq: this.selRTQ });
            this.isRTQFormVisible = false;
            this.showQuestionnaire = false;
            this.rtqTypeDesc = "";
        };
        
        initNewRTQ(rtqType: number): void {

            this.rtq = {};

            if (rtqType == 1)
                this.rtqTypeDesc = "Express";
            else
                this.rtqTypeDesc = "Standard";
            
            this.advisorService.getNewRTQ(rtqType)
                .success((data) => {

                    if (this.titleId)
                        data.titleId = this.titleId;

                    if (this.household)
                        data.householdId = this.household.id;

                    this.rtq = data;
                    
                    this.questionnaire = this.rtq.questionnaireResult.questionnaire;
                    this.results = this.rtq.questionnaireResult.results;
                    this.questionIndex = -1;
                    this.nextQuestion();
                    this.showQuestionnaire = true;                    
                })
                .error((data, status) => {
                    toastr.error("Error " + status + " " + data);
                });
        };
        
        nextQuestion(): void {

            if (this.resultDefined())
            {
                //console.log(this.questionnaire);
                toastr.warning("Please answer the question");
                return;
            }

            if (this.questionnaire.questions.length > (this.questionIndex + 1)) {                
                this.questionIndex++;
                this.question = this.questionnaire.questions[this.questionIndex];
                if (this.rtq && this.rtq.id > 0) {
                    //we need to find answer for current question
                    this.result = this.results.filter(item => item.questionId == this.question.id)[0];
                }
                else {
                    this.result = this.results[this.questionIndex];
                }
            }
        }

        previousQuestion(): void {
            if (this.questionIndex > 0 && this.questionnaire.questions.length > (this.questionIndex - 1)) {
                this.questionIndex--;
                this.question = this.questionnaire.questions[this.questionIndex];
                this.result = this.results[this.questionIndex];
            }
        }

      saveRTQ(): void {

        this.buttonDisabled = true;

            if (this.resultDefined()) {
              toastr.warning("Please answer the question");
              this.buttonDisabled = false;
                return;
            }

          if (this.rtqDescription.length < 1) {
              toastr.warning("Please enter RTQ name/description");
              this.buttonDisabled = false;
                return;
            }
            this.rtq.description = this.rtqDescription + " [" + this.rtqTypeDesc + "]";

            //console.log(this.rtq);

            this.advisorService.saveRTQ(this.rtq)
                .then(response => {
                    //console.log("RTQ Saved data", response.data);
                    if (this.rtqs && this.enableRtqSelect)
                        this.rtqs.push(response.data);
                    this.onRtqCu({ rtq: response.data });
                  this.selectRTQ(response.data);
                  this.buttonDisabled = false;
                }, err => toastr.error("RTQ has not been saved! Error " + err.status + " " + err.data));
        }

        finishRTQ(): void {            
            this.rtq.questionnaireResult.status = 1;

            this.saveRTQ();
        }

        resultDefined(): boolean {
            return this.questionIndex >= 0 && this.result.optionId == null && this.result.textAnswer == null && this.result.dateAnswer == null;
        };

        $onInit(): void {
            if (this.household)
                this.isRTQFormVisible = true;
        }

        $onChanges(evt): void {
            for (var key in evt) {
                if (key === "rtqs" && this.selRTQ == null) {
                    if (this.rtqs && this.rtqs.length > 0) {
                        this.selectRTQ(this.rtqs[0]);
                    }
                    else
                        this.selectRTQ(null);
                }
                if (key === "selGroupId") {
                    this.selGroupId = this.selGroupId;
                }
            }
        }
        
        $routerOnActivate(next, previous) {
        }

    } 

    
    class SelectCuRTQ implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;

        constructor() {
            this.controller = SelectCuRTQController;
            this.controllerAs = "vm";
            this.bindings = {
                titleId: "<",
                household: "<",
                rtq: "<",
                rtqs: "<",
                enableRtqSelect: "<",
                onRtqSelected: "&",
                onRtqCu: "&",
                selGroupId: "<",
                onGroupNameUpdated: "&"
            };
            this.templateUrl = "spa/shared/common/select-cu-rtq.html";
        }

    }
    angular.module(Constants.APP).component("selectCuRtq", new SelectCuRTQ());

}